<template lang='slm'>
  .container.table-responsive
    table.table.table-bordered
      thead
        tr
          th Картинка
          th Название
          th Исполнитель
          th Год
          th Песни
          th Действия
      tbody
        template v-for='item in items'
          tr
            td
              img.preview :src='"/api/file/" + item.coverId'
            td {{ item.title }}
            td {{ item.artist }}
            td {{ item.year }}
            td {{ item.songs.length }}
            td
              button.btn.btn-info.mr-2 type='button' @click='editItem(item)'
                icon name='pencil-alt'
              button.btn.btn-danger type='button' @click='deleteItem(item)'
                icon name='trash'
          tr
            td colspan=6
              table.table.table-bordered
                  thead
                    tr
                      th Сервис
                      th Ссылка
                      th
                  tbody
                    tr v-for='serviceLink in item.serviceLinks'
                      td {{ serviceLink.service }}
                      td
                        a :href='serviceLink.link' target='_blank' rel='noopener noreferrer' {{ serviceLink.link }}
                      td
                        button.btn.btn-danger type='button' @click='deleteServiceLink(item, serviceLink)'
                          icon name='trash'
              button.btn.btn-success.d-flex type='button' @click='addServiceLink(item)'
                icon.mr-2 name='plus'
                span Добавить ссылку
          tr
            td colspan=6
              table.table.table-bordered
                thead
                  tr
                    th Название
                    th Аудио
                    th Длительность
                    th Действия
                tbody
                  tr v-for='song, songIndex in item.songs'
                    td {{ song.title }}
                    td
                      audio controls='' preload='none'
                        source :src='"/api/file/" + song.fileId' type='audio/mp3'
                    td {{ song.duration | duration }}
                    td
                      button.btn.btn-secondary.mr-2 type='button' @click='moveSongUp(item, song)' :class='{ disabled: songIndex === 0 }'
                        icon name='sort-up'
                      button.btn.btn-secondary.mr-2 type='button' @click='moveSongDown(item, song)' :class='{ disabled: songIndex === item.songs.length - 1 }'
                        icon name='sort-down'
                      button.btn.btn-info.mr-2 type='button' @click='editSong(item, song)'
                        icon name='pencil-alt'
                      button.btn.btn-danger type='button' @click='deleteSong(item, song)'
                        icon name='trash'
              button.btn.btn-success.d-flex type='button' @click='addSong(item)'
                icon.mr-2 name='plus'
                span Добавить песню
    .text-left
      button.btn.btn-success.d-flex type='button' @click='addItem()'
        icon.mr-2 name='plus'
        span Добавить альбом
    modal ref='modal' @confirm='saveItem' title='Альбом'
      admin-album-modal-content
    modal ref='songModal' @confirm='saveSong' title='Песня'
      admin-album-song-modal-content
    modal ref='serviceLinkModal' @confirm='saveServiceLink' title='Ссылка'
      admin-album-service-link-modal-content
</template>

<script>
import Modal from '@/components/Modal';
import gql from 'graphql-tag';
import AdminAlbumModalContent from './_AdminAlbumModalContent';
import AdminAlbumSongModalContent from './_AdminAlbumSongModalContent';
import AdminAlbumServiceLinkModalContent from './_AdminAlbumServiceLinkModalContent';

function defaultModalItem() {
  return {
    id: null,
    coverId: null,
    title: '',
    artist: '',
    year: new Date().getYear() + 1900,
  };
}

function defaultSongModalItem() {
  return {
    id: null,
    title: '',
    duration: 0,
    fileId: null,
  };
}

function defaultServiceLinkModalItem() {
  return {
    service: '',
    link: '',
  };
}

const SONG_FIELDS = 'id title duration fileId order';
const SERVICE_LINK_FIELDS = 'id service link';
const ITEM_FIELDS = `id coverId title artist year hash songs { ${SONG_FIELDS} } serviceLinks { ${SERVICE_LINK_FIELDS} }`;
const GET_DATA_QUERY = gql`{ albums { ${ITEM_FIELDS} } }`;

function mutateChangeSongOrder(apollo, albumId, songId, newOrder) {
  return apollo.mutate({
    client: 'admin',
    mutation: gql`mutation MoveSongUp($id: Int!, $order: Int!) {
      changeSongOrder(id: $id, order: $order) { id order }
    }`,
    variables: {
      id: songId,
      order: newOrder,
    },
    update: (store, { data: { changeSongOrder: affectedSongs } }) => {
      const data = store.readQuery({ query: GET_DATA_QUERY });
      const albumIndex = data.albums.findIndex(album => album.id === albumId);
      if (albumIndex === -1) return;
      affectedSongs.forEach((affectedSong) => {
        const songIndex = data.albums[albumIndex].songs.findIndex(song => song.id === affectedSong.id);
        if (songIndex === -1) return;
        data.albums[albumIndex].songs[songIndex].order = affectedSong.order;
      });
      store.writeQuery({ query: GET_DATA_QUERY, data });
    },
  });
}

export default {
  name: 'AdminAlbums',
  components: {
    Modal, AdminAlbumModalContent, AdminAlbumSongModalContent, AdminAlbumServiceLinkModalContent,
  },
  apollo: {
    data: {
      client: 'admin',
      query: GET_DATA_QUERY,
      update(data) {
        this.items = data.albums.map(album => ({
          ...album,
          songs: album.songs.sort((a, b) => a.order - b.order),
        }));
      },
    },
  },
  data() {
    return {
      items: [],
    };
  },
  methods: {
    editItem(item) {
      this.$refs.modal.open(item);
    },
    addItem() {
      this.$refs.modal.open(defaultModalItem());
    },
    deleteItem(item) {
      this.$apollo.mutate({
        client: 'admin',
        mutation: gql`mutation DeleteAlbum($id: Int!) { deleteAlbum(id: $id) { id } }`,
        variables: { id: item.id },
        update: (store, { data: { deleteAlbum: { id: deleteItemWithId } } }) => {
          const data = store.readQuery({ query: GET_DATA_QUERY });
          data.albums = data.albums
            .filter(albumItem => albumItem.id !== deleteItemWithId);
          store.writeQuery({ query: GET_DATA_QUERY, data });
        },
      });
    },
    saveItem(item) {
      this.$apollo.mutate({
        client: 'admin',
        mutation: gql`mutation SaveAlbum($id: Int, $coverId: Int!, $title: String!, $artist: String!, $year: Int!) {
          saveAlbum(id: $id, coverId: $coverId, title: $title, artist: $artist, year: $year) { ${ITEM_FIELDS} }
        }`,
        variables: item,
        update: (store, { data: { saveAlbum: savedItem } }) => {
          const data = store.readQuery({ query: GET_DATA_QUERY });
          const index = data.albums.findIndex(album => album.id === savedItem.id);
          if (index === -1) {
            data.albums.push(savedItem);
          } else {
            data.albums[index] = savedItem;
          }
          store.writeQuery({ query: GET_DATA_QUERY, data });
        },
      }).then(() => this.$refs.modal.close());
    },
    editSong(album, song) {
      this.$refs.songModal.open({ album, song });
    },
    addSong(album) {
      this.$refs.songModal.open({ album, song: defaultSongModalItem() });
    },
    deleteSong(album, song) {
      this.$apollo.mutate({
        client: 'admin',
        mutation: gql`mutation DeleteSong($id: Int!) { deleteSong(id: $id) { id } }`,
        variables: { id: song.id },
        update: (store, { data: { deleteSong: { id: deleteSongWithId } } }) => {
          const data = store.readQuery({ query: GET_DATA_QUERY });
          const albumIndex = data.albums.findIndex(item => item.id === album.id);
          if (albumIndex === -1) return;
          const songIndex = data.albums[albumIndex].songs.findIndex(albumSong => albumSong.id === deleteSongWithId);
          if (songIndex === -1) return;
          const deletedSongOrder = data.albums[albumIndex].songs[songIndex].order;
          data.albums[albumIndex].songs.splice(songIndex, 1);
          data.albums[albumIndex].songs = data.albums[albumIndex].songs.map(albumSong => ({
            ...albumSong,
            order: (albumSong.order > deletedSongOrder) ? (albumSong.order - 1) : albumSong.order,
          }));
          store.writeQuery({ query: GET_DATA_QUERY, data });
        },
      });
    },
    saveSong(song) {
      this.$apollo.mutate({
        client: 'admin',
        mutation: gql`mutation SaveSong($id: Int, $title: String!, $fileId: Int!, $duration: Int!,  $albumId: Int!) {
          saveSong(id: $id, title: $title, fileId: $fileId, duration: $duration, albumId: $albumId) { ${SONG_FIELDS} }
        }`,
        variables: song,
        update: (store, { data: { saveSong: savedSong } }) => {
          const data = store.readQuery({ query: GET_DATA_QUERY });
          const albumIndex = data.albums.findIndex(dataAlbum => dataAlbum.id === song.albumId);
          if (albumIndex === -1) return;
          const songIndex = data.albums[albumIndex].songs.findIndex(dataSong => dataSong.id === savedSong.id);
          if (songIndex === -1) {
            data.albums[albumIndex].songs.push(savedSong);
          } else {
            data.albums[albumIndex].songs[songIndex] = savedSong;
          }
          store.writeQuery({ query: GET_DATA_QUERY, data });
        },
      }).then(() => this.$refs.songModal.close());
      // FIXME перезагрузить (.load()) соответствующий audio чтобы обновилась песня, если она была изменена
    },
    moveSongUp(item, song) {
      mutateChangeSongOrder(this.$apollo, item.id, song.id, song.order - 1);
    },
    moveSongDown(item, song) {
      mutateChangeSongOrder(this.$apollo, item.id, song.id, song.order + 1);
    },
    addServiceLink(album) {
      this.$refs.serviceLinkModal.open({ album, serviceLink: defaultServiceLinkModalItem() });
    },
    saveServiceLink(serviceLink) {
      this.$apollo.mutate({
        client: 'admin',
        mutation: gql`mutation SaveServiceLink($id: Int, $service: String!, $link: String!, $albumId: Int!) {
          saveServiceLink(id: $id, service: $service, link: $link, albumId: $albumId) { ${SERVICE_LINK_FIELDS} }
        }`,
        variables: serviceLink,
        update: (store, { data: { saveServiceLink: savedServiceLink } }) => {
          const data = store.readQuery({ query: GET_DATA_QUERY });
          const albumIndex = data.albums.findIndex(dataAlbum => dataAlbum.id === serviceLink.albumId);
          if (albumIndex === -1) return;
          const serviceLinkIndex = data.albums[albumIndex].serviceLinks.findIndex(dataServiceLink => dataServiceLink.id === savedServiceLink.id);
          if (serviceLinkIndex === -1) {
            data.albums[albumIndex].serviceLinks.push(savedServiceLink);
          } else {
            data.albums[albumIndex].serviceLinks[serviceLinkIndex] = savedServiceLink;
          }
          store.writeQuery({ query: GET_DATA_QUERY, data });
        },
      }).then(() => this.$refs.serviceLinkModal.close());
    },
    deleteServiceLink(album, serviceLink) {
      this.$apollo.mutate({
        client: 'admin',
        mutation: gql`mutation DeleteServiceLink($id: Int!) { deleteServiceLink(id: $id) { id } }`,
        variables: { id: serviceLink.id },
        update: (store, { data: { deleteServiceLink: { id: deleteServiceLinkWithId } } }) => {
          const data = store.readQuery({ query: GET_DATA_QUERY });
          const albumIndex = data.albums.findIndex(item => item.id === album.id);
          if (albumIndex === -1) return;
          const serviceLinkIndex = data.albums[albumIndex].serviceLinks.findIndex(albumServiceLink => albumServiceLink.id === deleteServiceLinkWithId);
          if (serviceLinkIndex === -1) return;
          data.albums[albumIndex].serviceLinks.splice(serviceLinkIndex, 1);
          store.writeQuery({ query: GET_DATA_QUERY, data });
        },
      });
    },
  },
};
</script>
